import type { JsonObject } from "@/api";
import { asLeaf, formatFieldValue, getAtPath } from "./recipeCoerce";

// 파싱된 config 트리를 override key 후보용으로 평탄화한다. 스칼라 leaf 만 dot-path 키로 담고,
// 리스트·중첩 맵은 제외한다(리스트 override 는 카탈로그 spec 또는 직접 입력으로 다룬다).

export function flattenRecipeScalars(data: JsonObject): Map<string, string> {
  const result = new Map<string, string>();
  walkScalars(data, "", result);
  return result;
}

function walkScalars(node: JsonObject, prefix: string, out: Map<string, string>): void {
  for (const [key, value] of Object.entries(node)) {
    const path = prefix === "" ? key : `${prefix}.${key}`;
    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      walkScalars(value as JsonObject, path, out);
      continue;
    }
    if (Array.isArray(value)) {
      continue;
    }
    out.set(path, formatFieldValue(asLeaf(value)));
  }
}

// 경로의 현재 config 값 표시 문자열(리스트 포함). leaf 가 아니거나 경로가 없으면 null 이다.
// override key 옵션의 "현재 값" 미리보기와 값 자동 채움에 쓴다.
export function recipeValueAt(data: JsonObject, path: string): string | null {
  const leaf = asLeaf(getAtPath(data, path));
  return leaf === undefined ? null : formatFieldValue(leaf);
}
